import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx"
import { Urls } from "../Urls";
import * as HtmlRequest from "../HtmlRequest";
import { Area } from "../General/Area";
import { AreaBody } from "../General/AreaBody";
import { DialogStore } from "../Stores/DialogStore";

type PathNameType = "imprint" | "legalnotice" | "applicationlead" | "privacypolicy";

interface IHtmlContentProps {
	location?: IHtmlContentPathNameProps;
}

interface IHtmlContentPathNameProps {
	pathname?: string;
}

@observer
export class HtmlContent extends React.Component<IHtmlContentProps, {}> {

	@observable url: string = "";
	@observable pathname: PathNameType;

	componentWillMount() {
		this.setHtmlcontentUrl();
		this.getHtmlContent(this.url);
	}

	componentDidUpdate() {
		this.setHtmlcontentUrl();
		this.getHtmlContent(this.url);
	}

	setHtmlcontentUrl = () => {
		this.pathname = this.props.location.pathname.replace("/", "") as PathNameType;
		switch (this.pathname) {
			case "imprint":
				this.url = Urls.imprint;
				break;
			case "legalnotice":
				this.url = Urls.legalNotices;
				break;
			case "applicationlead":
				this.url = Urls.applicationLead;
				break;
			case "privacypolicy":
				this.url = Urls.privacyPolicy;
				break;
			default:
				this.url = "";
		}
	}

	getHtmlContent = (url: string) => {
		if (url) {
			HtmlRequest.GetHtml(url).then(result => {
				this.refs.htmlContentComponent.innerHTML = result;
			}).catch(error =>
				DialogStore.showError("Error", error)
			);
		}
	}

	refs: {
		[key: string]: Element,
		htmlContentComponent: HTMLElement
	}

	render() {
		let htmlConentContainer = <div ref="htmlContentComponent" className="system-description"></div>;
		return <div className="html-content">
			{this.pathname === "applicationlead" ? htmlConentContainer : <Area>
				<AreaBody>
					<div className="area-grid__body-content">
						<div className="content-main">
							{htmlConentContainer}
						</div>
					</div>
				</AreaBody>
			</Area>}
		</div>
	}
}


